import React from 'react';
import { Trash2 } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { ToolBtn } from '../../shared/ui/tool-btn';
import { AutoFitTextbox, isAutoFitTextbox } from '../types';
import { AutoFitTextTypographyRow } from './auto-fit-text-typography-row';
import { AutoFitTextConstraintsRow } from './auto-fit-text-constraints-row';

export const AutoFitTextSettings: React.FC = () => {
  const { canvas, selectedObject, deleteSelected } = useEditorCanvas();
  if (!canvas || !isAutoFitTextbox(selectedObject)) return null;

  const textbox: AutoFitTextbox = selectedObject;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <AutoFitTextTypographyRow textbox={textbox} />
      <AutoFitTextConstraintsRow textbox={textbox} />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ToolBtn onClick={deleteSelected} variant='danger' title='Eliminar'>
          <Trash2 size={15} />
        </ToolBtn>
      </div>
    </div>
  );
};
